import './JpegToPdf.css';
import { useState } from 'react';
import jsPDF from 'jspdf'; 
import SharePage from '../SharePage.js';

let JpegToPdf=()=>{
    let [base64images, setbase64images]=useState(null);  
    let [multipleimages, setmultipleimages]= useState(null); 
    const handlefilechane=async(e)=>{
        document.querySelector(".selectedimgscont").style.display = "block";
        let files = e.target.files;
        let arryafiles = Array.from(files);  
        setmultipleimages(arryafiles);
         const base64promises =  arryafiles.map((file)=>
        convertbase64images(file))
        const base64Images = await Promise.all(base64promises);
        setbase64images(base64Images);
        if(files){ 
            document.querySelector(".convertbtn").style.display="block";
            // document.querySelector(".lablehide").style.display="none";
            
        } 
        document.querySelector(".imguploadcont").style.display="none";

    }
 // Make function to convert all images to base64 data url
    let convertbase64images=(file)=>{
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload =()=>
            resolve(reader.result);
            reader.onerror=(error)=> reject(error);
             
            
        });

    };
    // let deleteitemfromname=async(e)=>{
    //     setmultipleimages(removitem=>
    //     removitem.filter(itme => itme.name !== e.name)); 

    // } 
    const handleconvert=()=>{
            document.querySelector(".convertbtn").style.display="none";
            document.querySelector(".selectedimgscont").style.display="none";

        // create a new jspdf instance default is a4 size , portrait
        const pdf = new jsPDF();
        base64images.forEach((imagesrc,index)=>{
            if(index > 0){
                pdf.addPage();
            } 
            pdf.addImage(imagesrc, 'JPEG', 10, 10, 190, 280);
        });
        document.querySelector(".successfulmsgcont").style.display="block"; 
        document.querySelector(".message").innerHTML = "Converted successfully and downloaded";
        pdf.save('my-images.pdf');
        document.querySelector(".sharecont").style.display="block";
    }
    return(
        <div className='jpegtopdfmaincont'>
            <p className='imgreszerhead'>JPG TO PDF CONVERTER</p>
           
              
           
            <div className='imguploadcont'>
                <input style={{display:"none"}} accept="image/png, image/jpeg" multiple id='inpfile' onChange={handlefilechane} type='file'/>
                <label className='lablehide' htmlFor='inpfile'>Select Image to convert into PDF </label> 
                 
            </div>
           
            {/* <img style={{display:"none"}} className='imgimg' src={shwoimg}/> */}


       
                <div style={{display:"none"}} className='selectedimgscont'>
                    {
                    multipleimages !== null ? multipleimages.map(
                        aa=>(
                            <div className='imgcontt'>
                                {/* <span title="Remove" onClick={()=>{deleteitemfromname(aa)}} className='removemark'>X</span> */}
                                <img className='iimmgg' alt='photo'  src={URL.createObjectURL(aa)}/>
                            </div>

                        )
                    ) : "No file selected"
                }   
                </div>
                 
                <button className='convertbtn' style={{display:"none"}} onClick={handleconvert}>Convert & Download</button> 
                <div style={{display:"none"}} className='successfulmsgcont'>
                    <p style={{color:"green", fontSize:"24px"}} className='message'></p>
                    <div className='sharecont' style={{display:"none"}}>
                        <SharePage path='/Converter/jpegtopdf' title='Check out this awesome jpg to pdf converter tool' description="Convert your jpg/images into pdf"/>

                    </div>
                </div>
            
        </div>
    );
}
export default JpegToPdf;